export default {
  name: "BreadCrumb",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};